import { useClientRest } from "@shared/hooks";
import { toSnake, transformQueryParamsWithoutLocale } from "@shared/utils";
import { useQuery } from "@tanstack/react-query";
import { ActiveDocument } from "../types";

function buildUrl(filters?: { page?: number; keyword?: string; limit?: number; employerType?: string }): string {
  const params = toSnake({
    ...filters,
    page: filters?.page || 1,
    limit: filters?.limit || 10,
  });

  return transformQueryParamsWithoutLocale(`/karirhub/onboarding/v2/documents`, params);
}

export function useActiveDocuments({ filters }: { filters?: { page?: number; keyword?: string; limit?: number; employerType?: string } }) {
  const url = buildUrl(filters);

  const { request } = useClientRest();

  const query = useQuery<{ data: ActiveDocument[] }>({
    queryKey: ["active-documents-", filters?.employerType, filters?.keyword, filters?.limit, filters?.page],
    queryFn: () =>
      request({
        url: url,
        method: "GET",
        options: {
          cache: "no-store",
        },
      }),
    enabled: !!filters?.employerType,
  });

  const refetch = () => {
    query.refetch();
  };

  return {
    isLoading: query.isLoading,
    activeDocuments: query.data?.data || [],
    query,
    refetch,
  };
}
